// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--_RH6o","icon":"_7a3fb80146--icon--rN1O8"};